import { usedVehicleCertificationType, listIdentifiersForOCategory, listIdentifiersForLCategory } from '@/configs/constants'
import { list as statuses } from '@/configs/statuses'

export const isUsedInspectionRework = (statement, inspection) =>
  statement?.vehicle_condition === usedVehicleCertificationType &&
  statement?.status_document === statuses.statementWaitReprocessing &&
  (!inspection || [statuses.inspectionWaitComplianceCompleted, statuses.inspectionUploadProofs,
    statuses.inspectionWaitReprocessing]
    .includes(inspection.status_document))

export const complianceAnswersFingerprint = questions => JSON.stringify(questions.map(question => ({
  id: question.id,
  answer: question.answer,
  answer_text: question.answer_text || '',
  exception_codes: question.exception_codes || []
})))

export const complianceTabFingerprint = tab => complianceAnswersFingerprint(tab.inspection_questions)

export const inspectionReworkMeasurements = {
  lightTransmission: {
    state: 'lightTransmissionMeasurement', load: 'getLightTransmissionMeasurement', flag: 'has_light_transmission_inspection'
  },
  brake: { state: 'brakeMeasurement', load: 'getBrakeMeasurement', flag: 'has_brake_inspection' },
  light: { state: 'lightMeasurement', load: 'getLightMeasurement', flag: 'has_light_inspection' },
  gas: { state: 'gasMeasurement', load: 'getGasMeasurement', flag: 'has_gas_inspection' },
  smoke: { state: 'smokeMeasurement', load: 'getSmokeMeasurement', flag: 'has_smoke_inspection' },
  noise: { state: 'noiseMeasurement', load: 'getNoiseMeasurement', flag: 'has_noise_inspection' }
}

export const requiredInspectionReworkMeasurements = (inspection, statement) => {
  const vehicle = inspection.vehicle
  const isTrailer = listIdentifiersForOCategory.includes(vehicle.vehicle_category)
  const types = []
  if (!isTrailer && !listIdentifiersForLCategory.includes(vehicle.vehicle_category) &&
    inspection.vehicle_inspection_windows?.length) types.push('lightTransmission')
  if (!isTrailer || statement.presence_brake_system) types.push('brake')
  if (!isTrailer) {
    types.push('light')
    if ([1, 15, 17, 18, 19, 20, 28, 30, 32, 31].includes(vehicle.fuel_type)) types.push('gas')
    if ([2, 22, 29, 21, 27, 14].includes(vehicle.fuel_type)) types.push('smoke')
    if (types.includes('gas') || types.includes('smoke') || vehicle.fuel_type === 16) types.push('noise')
  }
  return types
}

